import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import * as config from '../../Config/environment.js';
import React,{useState} from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate,useParams } from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import Grid from '@mui/material/Grid';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ProgressBar } from 'primereact/progressbar';
import { Skeleton } from 'primereact/skeleton';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Tooltip } from 'primereact/tooltip';
import { Slider } from "primereact/slider";
import { Galleria } from 'primereact/galleria';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import {Panel} from 'primereact/panel';
import { Message } from 'primereact/message';
import { ConfirmDialog } from 'primereact/confirmdialog'; // For <ConfirmDialog /> component
import { confirmDialog } from 'primereact/confirmdialog'; // For confirmDialog method

import 'moment/locale/pt-br';
// import moment from "moment";
import moment, { lang } from 'moment-business-days';


// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as OrderActions from '../../Store/Actions/Order'

import AboutUs from '../../Components/layout/AboutUs';
import ContactUs from '../../Components/layout/ContactUs';

import iconResponsibleWarning from '../../Assets/Images/iconResponsibleWarn.svg';
import iconDownload from '../../Assets/Images/iconDownload.svg';
import iconNewBooking from '../../Assets/Images/iconNewBooking.svg';

import visa_icon from '../../Assets/Images/visa_icon.svg';
import mastercard_icon from '../../Assets/Images/mastercard_icon.svg';
import creditcard_icon from '../../Assets/Images/creditcard_icon.svg';


// import Timer from '../../Components/Timer'; WEB WORKER FOR BACKGROUND TASK

// Load Componentes 
import AlertView from '../../Components/AlertModal';
import TermsView from '../../Components/TermsModal';

import {
    formatNumberCurrency,
    validarNumeroCartao,
    validarNomeCartao,
    validarValidadeCartao,
    getCardBrand,
    maskCardExpiry,
    maskCPF,
    maskCreditcard
} from '../../Components/Utils';

// Set booking timer
var bookingTimer;

// export default function HomePage() {
const BookingPayment = (props) => {
    
// Set var from props
const {
    setDialog,
    dialog,
    currentAgency,
    searchParams,
    exchangeRates,
    selectedProperty,
    setSelectedProperty,
    downloadQuotePdf,
    retrievePersonInfoByDocument,
    createBooking,
    setCurrentBooking,
    currentBooking,
    deleteDirectSearchResult,
    searchResultToken,
    paymentConfirmed,
    setPaymentConfirmed,
    setPaymentTransaction,
    paymentTransaction,
    setExchangeRates
} = props;

// Mapeamento das marcas para os ícones
const cardIcons = {
  visa: visa_icon,
  mastercard:mastercard_icon,
  creditcard: creditcard_icon,
};

// set bookingdata
const bookingDataTmp = selectedProperty?.bookingData || {};

 
// console.log('[selectedProperty]--------->]'+JSON.stringify(selectedProperty, null, 2));
// console.log('[exchangeRates]--------->]'+JSON.stringify(exchangeRates, null, 2));
//console.log('[paymentTransaction]--------->]'+JSON.stringify(paymentTransaction, null, 2));

const [propertyId, setPropertyId] = useState(null); 

const [creatingBooking, setCreatingBooking] = useState(false); 
const [loadingFiltering, setLoadingFiltering] = useState(false); 
const [loading, setLoading] = useState(true); 
const [saving, setSaving] = useState(false); 
const [verifyStatusLoading, setVerifyStatusLoading] = useState(false); 


const [contentLoaded, setContentLoaded] = useState(false); 
const [hostingOption, setHostingOptions] = useState(false); 
const [currentStep, setCurrentStep] = useState(1); // 1 continent - 2 country - 3 city  - 4 options

const [contentLoading, setContentLoading] = useState(true); 
const [loadingPayment, setLoadingPayment] = useState(false); 

const [currentContinent, setCurrentContinent] = useState({}); // id and label
const [currentCountry, setCurrentCountry] = useState({}); // id and label
const [currentCity, setCurrentCity] = useState({}); // id and label

const [breadcrumbArray, setBreadcrumbArray] = useState([]); // id and label
    
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

    
// Alert control
const [alert, setAlert] = useState(false); 
const [alertTitle, setAlertTitle] = useState("Informações"); 
const [alertBody, setAlertBody] = useState("Conteúdo dinâmico"); 
const [alertAction, setAlertAction] = useState(""); 

const [currentPlaces, setCurrentPlaces] = useState([]); 		

const [hostsAndRoomsLabel, setHostsAndRoomsLabel] = useState(null); 
const [hostsLabel, setHostsLabel] = useState(null); 
const [roomsLabel, setRoomsLabel] = useState(null); 
const [dateRangeDays, setDateRangeDays] = useState(null); 

const [hostsAndRooms, setHostsAndRooms] = useState(null); 
const [rooms, setRooms] = useState([{ adults: 2, children: [] }]);
const [selectedRooms, setSelectedRooms] = useState([]); 

const [currencyCollectedFeeAmount, setCurrencyCollectedFeeAmount] = useState(null); 
const [totalAmountGrouped, setTotalAmountGrouped] = useState(""); 
const [localCollectedFeeItems, setLocalCollectedFeeItems] = useState([]); 

const [imageWithError, setImageWithError] = useState(0);

const [dateRange, setDateRange] = useState([]);
const [formattedValue, setFormattedValue] = useState('');

// Exchange rate USD
const [usdExchangeRate, setUsdExchangeRate] = useState(null);
const [exchangeRateInitials, setExchangeRateInitial] = useState("USD");

// Booking details
const [responsibleDocumentType, setResponsibleDocumentType] = useState(bookingDataTmp?.bookingPaymentResponsible?.documentType || false);
const [responsibleDocument, setResponsibleDocument] = useState(bookingDataTmp?.bookingPaymentResponsible?.document || "");
const [responsibleName, setResponsibleName] = useState(bookingDataTmp?.bookingPaymentResponsible?.completeName || "");
const [responsibleBirthDate, setResponsibleBirthDate] = useState(bookingDataTmp?.bookingPaymentResponsible?.birthDate ? moment(bookingDataTmp?.bookingPaymentResponsible?.birthDate).format("DD/MM/YYYY") : "");
const [responsibleEmail, setResponsibleEmail] = useState(bookingDataTmp?.bookingPaymentResponsible?.email || "");
const [responsiblePhone, setResponsiblePhone] = useState(bookingDataTmp?.bookingPaymentResponsible?.mobilePhone || ""); 
const [responsibleIsGuest, setResponsibleIsGuest] = useState(bookingDataTmp?.bookingPaymentResponsible?.isGuest || true);

// Set and keep booking data state
const [bookingData, setBookingData] = useState(bookingDataTmp || {});

// console.log('[responsibleDataFetched]--------->]'+JSON.stringify(responsibleDataFetched, null, 2));

// Guests
const [hostsArray, setHostsArray] = useState([]); // Array to store hosts and children for forms
const [panelVisibility, setPanelVisibility] = useState({});
const [hostDocumentType, setHostDocumentType] = useState({});
const [hostNoCpf, setHostNoCpf] = useState({});
const [hostDocument, setHostDocument] = useState({});
const [hostName, setHostName] = useState({});
const [hostBirthdate, setHostBirthdate] = useState({});
const [hostDataFetched, setHostDataFetched] = useState({});
const [hostManualEdit, setHostManualEdit] = useState({});
const [hostFetching, setHostFetching] = useState({});  


const [totalAmountPaidNow, setTotalAmountPaidNow] = useState(0.00); 
const [totalAmountPaidNowNoComission, setTotalAmountPaidNowNoComission] = useState(0.00);
const [totalAmountPaidNoComission, setTotalAmountPaidNoComission] = useState(0.00); 

const [totalAmount, setTotalAmount] = useState(0.00); 
const [totalAmountNoComission, setTotalAmountNoComission] = useState(0.00); 

const [advanceComission, setAdvanceComission] = useState(false);
const [advanceComissionPercentage, setAdvanceComissionPercentage] = useState(0);
const [advanceComissionAmount, setAdvanceComissionAmount] = useState(0);

const [exchangeRate, setExchangeRate] = useState(null);
const [exchangeRateCurrency, setExchangeRateCurrency] = useState("BRL"); 
const [exchangeRateFormatted, setExchangeRateFormatted] = useState(null);
const [exchangeRateExpiration, setExchangeRateExpiration] = useState(null);

/* Get out and get in to screen control.  */
const [lastHiddenTime, setLastHiddenTime] = React.useState(null);
const timeoutMinutes = config.BUSINESS_RULES.timeoutMinutes; // Tempo em minutos


/*
console.log('[totalAmount]--------->]'+JSON.stringify(totalAmount, null, 2));
console.log('[totalAmountNoComission]--------->]'+JSON.stringify(totalAmountNoComission, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));
console.log('[totalAmountPaidNowNoComission]--------->]'+JSON.stringify(totalAmountPaidNowNoComission, null, 2));
console.log('[totalAmountPaidNoComission]--------->]'+JSON.stringify(totalAmountPaidNoComission, null, 2));

console.log('[advanceComission]--------->]'+JSON.stringify(advanceComission, null, 2));
console.log('[advanceComissionPercentage]--------->]'+JSON.stringify(advanceComissionPercentage, null, 2));
console.log('[advanceComissionAmount]--------->]'+JSON.stringify(advanceComissionAmount, null, 2));

console.log('[exchangeRate]--------->]'+JSON.stringify(exchangeRate, null, 2));*/


// tab control
const [activeIndex, setActiveIndex] = useState(0); // 0 - creditcard | 1 - pix

// Credit card control
// ...adicione ao início do seu componente React...

const [formFields, setFormFields] = React.useState({
  cardNumber: '',
  cardBrand: '',
  cardHolderName: '',
  cardExpiry: '',
  cardCvv: '',
  cardHolderCpf: responsibleDocument,
  installments: '',
  installmentsLabel: '',
});

const [installmentsOptions, setInstallmentsOptions] = useState([]);
const [paymentStatus, setPaymentStatus] = useState('CREATING');

// console.log('[hostDataFetched]--------->]'+JSON.stringify(hostDataFetched, null, 2));

// Room
const [roomAdditionalInfo, setRoomAdditionalInfo] = useState("");
const maxChars = 150;
const isLimitReached = roomAdditionalInfo.length === maxChars;

const [roomExtraInfo, setRoomExtraInfo] = useState("");
const [roomCancelPolicy, setRoomCancelPolicy] = useState("");

// Action buttons
const [loadingQuote, setLoadingQuote] = useState(false);
const [loadingSendEmail, setLoadingSendEmail] = useState(false);
const [loadingNewBooking, setLoadingNewBooking] = useState(false);

// Collected Fees
const [collectedFeeDetails, setCollectedFeeDetails] = React.useState([]);
const [nonUsdFees, setNonUsdFees] = React.useState([]);

// Terms and Conditions
const [acceptTerm, setAcceptTerm] = React.useState(false);
const [termsModal, setTermsModal] = React.useState(false); 


const calcularIdade = (data,targetDate=null) => {
  if (!data) return '';

  // Tenta primeiro no formato DD/MM/YYYY
  let birth = moment(data, 'DD/MM/YYYY', true);

  // Se não for válido, tenta como data raw (pode ser ISO, timestamp, etc.)
  if (!birth.isValid()) {
    birth = moment(data);
  }

  if (!birth.isValid()) return '';

  // Return age     
  if (targetDate) {
    return moment(targetDate).diff(birth, 'years');
  } else {
    return moment().diff(birth, 'years');
  }

};

// useRef 
const toast = React.useRef(null);

/* Activate Success Toast  */
const showSuccess = (title="",message="") => {
    toast.current.show({severity:'success', summary: title, detail:message, life: 6000});
}

/* Activate Error Toast  */
const showError = (title="",message="") => {
    toast.current.show({severity:'error', summary: title, detail:message, life: 6000});
}

/* Activate Warning Toast  */
const showWarning = (title="",message="") => {
    toast.current.show({severity:'warn', summary: title, detail:message, life: 6000});
}

// Configurar feriados nacionais e municipais do Rio de Janeiro
moment.updateLocale('pt-br', {
    holidays: config.BUSINESS_RULES.holidays,
    holidayFormat: 'YYYY-MM-DD'
});

// Controle dos campos do cartão
const handleFieldChange = (field, value) => {
  setFormFields(prev => ({
    ...prev,
    [field]: value
  }));
};

const handleBlur = () => {
  // Pode adicionar lógica de validação global aqui, se necessário
};

const handleClickScroll = (target,displacement=70) => {
		
	const element = document.getElementById(target);
	if (element) {
		// 👇 Will scroll smoothly to the top of the next section
		var elementPosition = element.offsetTop - displacement;
		element.scrollIntoView({ top: elementPosition,behavior: 'smooth' });
	}
};  


React.useEffect(() => {
    
    // Verifica se o exchangeRates está definido e não é nulo
    if (exchangeRates && exchangeRates.length > 0) {
        // Define a taxa de câmbio USD
        const result = exchangeRates.find(item => item.targetCurrencyInitials === "USD");
        if (result) {
            setExchangeRate(result.value);
            setExchangeRateFormatted(result.valueFormatted); // Define a moeda inicial como BRL
            setExchangeRateExpiration(moment(result.dateExpiration).format('DD/MM/YYYY')); // Formata a data de expiração

            // Set comisison amount after currency convertion
            const totalAmount = parseFloat(totalAmountPaidNow) * parseFloat(result.value);
            const calculatedAmount = (totalAmount * advanceComissionPercentage) / 100;
            setAdvanceComissionAmount(calculatedAmount.toFixed(2));  

        } else {
            console.error("USD exchange rate not found in exchangeRates.");
        }
    } else {
        console.error("exchangeRates is not defined or empty.");
    }    

}, [exchangeRates]);


React.useEffect(() => {
    if (!hostsAndRooms) {
        setHostsAndRooms(null);
    }	
}, [hostsAndRooms]);

React.useEffect(() => {
    if (dateRange && dateRange[0] && dateRange[1]) {
        const diffTime = Math.abs(dateRange[1] - dateRange[0]);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const formattedRange = formatDateRange(dateRange);
        let nightLabel = diffDays == 1 ? "noite" : "noites";
        setFormattedValue(`${formattedRange} (${diffDays} ${nightLabel})`);
    } else {
        setFormattedValue('');
    }
}, [dateRange]);

React.useEffect(() => {

    if (!currentBooking.property) {
        console.log('[CURRENT BOOKING DOES NOT EXIST - GO TO ORDER]--------->]');
        //navigate("/order");
    } // if
    else {
    }

}, [currentBooking]);

const formatDateRange = (range) => {
    if (range && range[0] && range[1]) {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return `${range[0].toLocaleDateString('pt-BR', options)} - ${range[1].toLocaleDateString('pt-BR', options)}`;
    }
    return '';
};
  
 
// Set calendar locale
addLocale('br', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Limpar'
});


// set Use of history for PUSH 
var navigate = useNavigate();

// Function to retrieve company comission
const executeRetrieveCompanyComission = () => {
    
    const data = {
        currentAgency: currentAgency || null,
    }
    
    // Retrieve company comission
    props.retrieveCompanyComission(data).then((response) => {

        if (response.success) {

            const customComission = response.customComission || null;
            const globalComission = response.globalComission || null;

            const paymentMethodCode = activeIndex === 0 ? "cc" : "pix"; 
            const selectedComissionArray = customComission || globalComission || [];
            
            const selectedComissionRes = selectedComissionArray?.filter(item => item.paymentMethod === paymentMethodCode);
            const appliedComission = selectedComissionRes?.length > 0 ? parseFloat(selectedComissionRes[0].comission) : null;           
            setAdvanceComissionPercentage(appliedComission); // Default to 0% if no comission is set

        } else {
            showError("Erro ao recuperar comissão da empresa", response.message || "Erro desconhecido");
        }
    }).catch((error) => {
        showError("Erro ao recuperar comissão da empresa", "Erro desconhecido");
    });

}

// Function to retrieve exchange rate
const executeRetrieveExchangeRate = () => {

    // Retrieve company comission
    props.retrieveExchangeRate().then((response) => {

        if (response.success) {

            const exchangeRatesRes = response.exchangeRates || null;
            setExchangeRates(exchangeRatesRes);

        } else {
            showError("Erro ao recuperar taxa de câmbio", response.message || "Erro desconhecido"); 
        }
    }).catch((error) => {
        showError("Erro ao recuperar taxa de câmbio", "Erro desconhecido");
    });

}


React.useEffect(() => {

    // Retrieve company comission
    executeRetrieveCompanyComission();

    // Retrieve exchange rate
    executeRetrieveExchangeRate();

}, [activeIndex]);

 
/* Execute when advanceComission change */
React.useEffect(() => {
    const totalAmount = parseFloat(totalAmountPaidNow);
    const minimumInstallment = 25; // valor mínimo em USD
    const installmentOptionsArray = [];

    // Cálculo da comissão do agente (sempre com base no valor original)
    const calculatedAmount = (totalAmount * advanceComissionPercentage) / 100;
    setAdvanceComissionAmount(calculatedAmount);

    handleFieldChange('installments', null);
    handleFieldChange('installmentsLabel', null);

    if (advanceComission) {

        // total sem comissão
        const totalWithoutComission = totalAmount - calculatedAmount;
        setTotalAmountPaidNowNoComission(totalWithoutComission);

        for (let i = 1; i <= 12; i++) {
            let installmentValue = totalWithoutComission / i;

            if (installmentValue >= minimumInstallment) {
                // arredonda sempre para 2 casas, mas ajusta última parcela
                let parcelas = Array(i).fill(0).map((_, idx) => {
                    return idx === i - 1
                        ? parseFloat((totalWithoutComission - (installmentValue.toFixed(2) * (i - 1))).toFixed(2))
                        : parseFloat(installmentValue.toFixed(2));
                });

                installmentOptionsArray.push({
                    label: `${i}x sem juros de ${formatNumberCurrency(parcelas[0] * exchangeRate, exchangeRateCurrency)}`,
                    value: i,
                });
            }
        }
    } else {

        for (let i = 1; i <= 12; i++) {
            
            let installmentValue = totalAmount / i;

            if (installmentValue >= minimumInstallment) {

                let parcelas = Array(i).fill(0).map((_, idx) => {
                    return idx === i - 1
                        ? parseFloat(installmentValue.toFixed(2))
                        : parseFloat(installmentValue.toFixed(2));
                });

                installmentOptionsArray.push({
                    label: `${i}x sem juros de ${formatNumberCurrency(parcelas[0] * exchangeRate, exchangeRateCurrency)}`,
                    value: i,
                });

            }
        }
    }

    setInstallmentsOptions(installmentOptionsArray);

}, [advanceComission, advanceComissionPercentage]);
// }, [totalAmountPaidNow, totalAmountPaidNowNoComission, advanceComission, advanceComissionPercentage]);


// Runs when opens component
React.useEffect(() => {

    // Retrieve User Data Obj. 
    var result = localStorage.getItem("@dream4/userData", undefined,true);
    var userData = JSON.parse(result);  

      // If token dont exist, redirect to onboarding or register
      if (!userData) {
        console.log('[REDIRECIONOU PRA HOME. KOSSOMAK]--------->]');
        //  navigate("/home");
        //  return;
      } // end if
      
  // set scroll to top
  //window.scrollTo(0, 1);

  // Simulate loading off
  setTimeout(() => {
    setContentLoading(false);
    handleClickScroll("navigationSection");
  }, 1000);

  // reset loading
  setCreatingBooking(false);

  // SIMULATE PAYMENT CONFIRMED
  setPaymentConfirmed(false);
  setPaymentTransaction({});
  /*setPaymentTransaction({
    code: "1234567890",
    bookingId:"DFGT-23DFG",
    amount: totalAmount,
    currency: exchangeRateCurrency
  });*/

// Set USD exchange Rate and currency initials
if (searchParams?.country?.code == "BR") {
    const result = exchangeRates.find(item => item.targetCurrencyInitials === "USD");
    const exchangeRateValue = result.value;
    setUsdExchangeRate(exchangeRateValue); 
    setExchangeRateInitial("BRL"); 
}  
    
  // Runs when UNMOUNT component
  return () => {

    setContentLoading(true); 
    setContentLoaded(false); 
    setHostingOptions(false); 
    setCurrentStep(1); 

    setCurrentContinent({}); 
    setCurrentCountry({}); 
    setCurrentCity({}); 
    setBreadcrumbArray([]); 

    setCurrentPlaces([]); 		
    setHostsAndRooms(null); 
    setRooms([{ adults: 2, children: [] }]); 
        
    setDateRange(null); 
    setFormattedValue('');

    setImageWithError(0);

    setCreatingBooking(false);
    
  };
  
}, []); // end useEffect 


React.useEffect(() => {
    // Calcula a soma total antes de atualizar o estado
    const total = selectedProperty.room.reduce((sum, item) => sum + (item.updatedPriceWithMarkup ? item.updatedPriceWithMarkup : item.totalWithMarkup), 0);

    // Set total amount paid now
    setTotalAmountPaidNow(total);

    // Set total amount with no comission
    const comissionFee = (total * advanceComissionPercentage) / 100;
    setTotalAmountPaidNowNoComission(total - comissionFee);


    const feesByCurrency = {};

    selectedProperty.room.forEach(item => {
        let fees = [];

        // Caso array direto
        if (Array.isArray(item.localCollectedFee)) {
            fees = item.localCollectedFee;
        }
        // Caso objeto com fees
        else if (item.localCollectedFee && Array.isArray(item.localCollectedFee.fees)) {
            fees = item.localCollectedFee.fees;
        }

        fees.forEach(fee => {
            if (fee.relation === "display" || fee.relation === undefined) {
                const feeCurrency = fee.currency;
                if (!feesByCurrency[feeCurrency]) {
                    feesByCurrency[feeCurrency] = 0;
                }
                feesByCurrency[feeCurrency] += fee.total || 0;
            }
        });
    });

    const usdFee = feesByCurrency["USD"] || 0;
    let grandTotal = total + usdFee;
    setTotalAmount(grandTotal);

    // Fees não-USD para Total
    const nonUsd = Object.entries(feesByCurrency)
        .filter(([currency]) => currency !== "USD")
        .map(([currency, total]) => ({ currency, total }));
    setNonUsdFees(nonUsd);

    // Para "Pagar na propriedade"
    const feeCurrencies = Object.keys(feesByCurrency);

    let payAtPropertyDetails = [];
    if (feeCurrencies.length === 1) {
        const singleCurrency = feeCurrencies[0];
        payAtPropertyDetails = [{
            currency: singleCurrency,
            total: feesByCurrency[singleCurrency],
        }];
    } else {
        payAtPropertyDetails = Object.entries(feesByCurrency).map(([currency, total]) => ({
            currency,
            total
        }));
    }

    setCollectedFeeDetails(payAtPropertyDetails);

    // Prepara array de hosts para forms
    let hostsArray = [];
    let currentIndex = 0;
    const room = selectedProperty?.hostsAndRoomsArray || [];
    const hostsAdults = room?.adults || 0;
    const childrenArr = Array.isArray(room?.children) ? room.children : [];
    const hostsChildren = childrenArr.length;

    for (let i = 0; i < hostsAdults; i++) {
        hostsArray.push({ type: 'adult', index: currentIndex });
        currentIndex++;
    }
    for (let i = 0; i < hostsChildren; i++) {
        hostsArray.push({ type: 'child', age: childrenArr[i].age || 0, index: currentIndex });
        currentIndex++;
    }
    setHostsArray(hostsArray);

    // Set label agrupado
    if (nonUsd.length > 0) {
        const formattedNonUsd = nonUsd.map(fee => `${formatNumberCurrency(fee.total, fee.currency)}`).join(" + ");
        setTotalAmountGrouped(`${formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)} + ${formattedNonUsd}`);
    } else {
        setTotalAmountGrouped(formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials));
    }

    // Set labels
    selectedProperty.room.map((item, index) => {
        const valueAdds = item.valueAdds ? item.valueAdds?.["value-add"] : item?.["value-adds"]?.["value-add"];

        const hasCode = (code) => {
            if (!valueAdds) return false;
            if (Array.isArray(valueAdds)) {
                return valueAdds.some((valueAdd) => valueAdd.code === code);
            }
            return valueAdds.code === code;
        };

        if (selectedProperty.origin == "hyperguest") {
            const daysBefore = item.cancellationPolicies?.[0]?.daysBefore || 0;
            const cancellationDeadline = moment(dateRange[0]).businessSubtract(daysBefore, 'days').format('YYYY-MM-DD')
            item['cancellation-deadline'] = cancellationDeadline;
        }

        const hasFreeCancellation = item['cancellation-deadline'] ? item['cancellation-deadline'] : false;
        const hasFreeBreakfast = hasCode("free_breakfast");

        setRoomExtraInfo(hasFreeBreakfast ? "Café da manhã incluído" : "Nenhuma opção extra");
        setRoomCancelPolicy(hasFreeCancellation ? `Cancelamento Gratuito até ${moment(item['cancellation-deadline']).businessSubtract(2, 'days').format('DD/MM/YYYY')}` : "Nenhuma opção de cancelamento");

        const rawFee = item?.localCollectedFee?.fees || item?.localCollectedFee;
        const localCollectedFee = Array.isArray(rawFee) ? rawFee.filter(f => f?.relation === 'display' || f?.relation === undefined) : rawFee;
        setLocalCollectedFeeItems(localCollectedFee || []);
    });

}, [selectedProperty]);


// Handle download quote PDF
const handleDownloadQuote = async () => {

  setLoadingQuote(true);


  // dOWNLOAD STARTED
    toast.current.show({ severity: 'info', summary: 'Gerando cotação', detail: 'O PDF está sendo gerado, por favor aguarde...', life: 4000 });


  const hotel = selectedProperty.property;
  const room = selectedProperty.room[0];
  const enriched = room.enrichedData || {};
  const contact = enriched.contact || {};

  const data = {
    hotel_name: hotel.hotel_name +" - "+ selectedProperty.property.country +", "+selectedProperty.property.city,
    booking_period: `${moment(selectedProperty.dateRange[0]).format("DD/MM/YYYY")} a ${moment(selectedProperty.dateRange[1]).format("DD/MM/YYYY")}`,
    booking_number: paymentTransaction?.bookingId || "N/A",
    hotel_address: hotel.hotel_address + ", " + selectedProperty.property.city +", "+selectedProperty.property.country,
    hotel_contact: {
      tel: hotel.phone ? hotel.phone : (contact.phone || ''),
      email: hotel.email ? hotel.email : (contact.email || ''),
      site: hotel.website ? hotel.website : (contact.website || '')
    },
    hotel_checkin: hotel?.checkin || "15:00 (confirmar com o hotel)",
    hotel_checkout: hotel?.checkout || "12:00 (confirmar com o hotel)",
    hotel_min_age_checkout: hotel?.min_age_checkout || "18",
    cancellation_deadline: roomCancelPolicy || '',
    cancellation_policy: room['cancellation-policy'] || '',
    total_amount: totalAmount
    ? `${formatNumberCurrency(totalAmount, exchangeRateInitials)}${
        nonUsdFees.length > 0 
          ? nonUsdFees.map(fee => ` + ${formatNumberCurrency(fee.total, fee.currency)}`).join('')
          : ''
      }`
    : '',

    total_booking: totalAmountPaidNow 
    ? `${formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}` 
    : '',

    total_local: collectedFeeDetails && collectedFeeDetails.length > 0
    ? collectedFeeDetails.map(fee => `${formatNumberCurrency(fee.total, fee.currency)}`).join(' + ')
    : "0",
    additional_fees: (localCollectedFeeItems && localCollectedFeeItems.length > 0)
      ? localCollectedFeeItems.map(item => ({
          name: item.name,
          value: `${formatNumberCurrency(item.total, item.currency || currencyCollectedFeeAmount)}`
        }))
      : [],
    room: {
      title: room.room.title,
      room_name: room.extraDetails?.name?.en || '',
      room_responsible_name: bookingData?.bookingVoucherInfo?.room?.room_responsible_name || '',
      room_hosts_label: selectedProperty.hostsLabel,
      room_extra: bookingData?.bookingVoucherInfo?.room?.room_extra || 'Nenhum extra incluído',
      room_additional_info: bookingData?.bookingVoucherInfo?.room?.room_additional_info || '- Nenhuma informação adicional-'
    }
  };

  const result = await downloadQuotePdf(data,'receipt'); 

  setTimeout(() => {
    
    
    setLoadingQuote(false)

    if (result.success) {
        showSuccess("Download iniciado!", "O arquivo será baixado em instantes.");
    } else {
        toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Falha ao gerar PDF.', life: 4000 });
    }

  }, 2000);


};

// Handle download voucher PDF
const handleDownloadVoucher = async () => {

  setLoadingQuote(true);

  // dOWNLOAD STARTED
    toast.current.show({ severity: 'info', summary: 'Gerando cotação', detail: 'O PDF está sendo gerado, por favor aguarde...', life: 4000 });


  const data = generateVoucherInfo();


  const result = await downloadQuotePdf(data,'voucher'); 

  setTimeout(() => {
    
    
    setLoadingQuote(false)

    if (result.success) {
        showSuccess("Download iniciado!", "O arquivo será baixado em instantes.");
    } else {
        toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Falha ao gerar PDF.', life: 4000 });
    }

  }, 2000);


};

const handleNewBooking = () => {

    setLoadingNewBooking(true);

    // Destrou current selected property
   // setSelectedProperty(null);

    setTimeout(() => {
        setLoadingNewBooking(false);
        // Show success message
        showSuccess("Nova reserva", "Você será redirecionado para a página de pesquisa de hotéis.");
        navigate("/order");
    }, 1000);

};

/* Execute function after some time away from the screen. to avoid old vars to be used */
  React.useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        // Quando a aba fica inativa, salva o tempo atual
        setLastHiddenTime(Date.now());
      } else if (document.visibilityState === "visible") {
        // Quando a aba volta a ficar ativa
        if (lastHiddenTime) {
          const elapsedMinutes = (Date.now() - lastHiddenTime) / (1000 * 60); // Calcula o tempo em minutos
          if (elapsedMinutes >= timeoutMinutes) {
            executeRetrieveExchangeRate(); // Get latest exchange rate
          }
        }
        setLastHiddenTime(null); // Reseta o último tempo ao retornar
      }
    };

    // Adiciona o listener para detectar mudança de visibilidade
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      // Remove o listener ao desmontar o componente
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [lastHiddenTime]);


// HELPER Generate voucher info for PDF
const generateVoucherInfo = () => {
    
  const hotel = selectedProperty.property;
  const room = selectedProperty.room[0];
  const enriched = room.enrichedData || {};
  const contact = enriched.contact || {};

  const data = {
    hotel_name: hotel.hotel_name +" - "+ selectedProperty.property.country +", "+selectedProperty.property.city,
    booking_period: `${moment(selectedProperty.dateRange[0]).format("DD/MM/YYYY")} a ${moment(selectedProperty.dateRange[1]).format("DD/MM/YYYY")}`,
    booking_number: selectedProperty?.bookingReservationCode || "N/A",
    hotel_address: hotel.hotel_address + ", " + selectedProperty.property.city +", "+selectedProperty.property.country,
    hotel_contact: {
      tel: hotel.phone ? hotel.phone : (contact.phone || ''),
      email: hotel.email ? hotel.email : (contact.email || ''),
      site: hotel.website ? hotel.website : (contact.website || '')
    },
    hotel_checkin: hotel?.checkin || "15:00 (confirmar com o hotel)",
    hotel_checkout: hotel?.checkout || "12:00 (confirmar com o hotel)",
    hotel_min_age_checkout: hotel?.min_age_checkout || "18",
    cancellation_deadline: roomCancelPolicy || '',
    cancellation_policy: room['cancellation-policy'] || '',
    total_amount: totalAmount
    ? `${formatNumberCurrency(totalAmount, exchangeRateInitials)}${
        nonUsdFees.length > 0 
          ? nonUsdFees.map(fee => ` + ${formatNumberCurrency(fee.total, fee.currency)}`).join('')
          : ''
      }`
    : '',

    total_booking: totalAmountPaidNow 
    ? `${formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}` 
    : '',

    total_local: collectedFeeDetails && collectedFeeDetails.length > 0
    ? collectedFeeDetails.map(fee => `${formatNumberCurrency(fee.total, fee.currency)}`).join(' + ')
    : "0",
    additional_fees: (localCollectedFeeItems && localCollectedFeeItems.length > 0)
      ? localCollectedFeeItems.map(item => ({
          name: item.name,
          value: `${formatNumberCurrency(item.total, item.currency || currencyCollectedFeeAmount)}`
        }))
      : [],
    room: {
      title: room.room.title,
      room_name: room.extraDetails?.name?.en || '',
      room_responsible_name: responsibleName || '',
      room_hosts_label: selectedProperty.hostsLabel,
      room_extra: roomExtraInfo || 'Nenhum extra incluído',
      room_additional_info: roomAdditionalInfo || ''
    },
    bookingPaymentResponsible: {
        completeName: responsibleName ?? "",
        email: responsibleEmail ?? "",
        mobilePhone: responsiblePhone ?? ""
    }    
  };

    return data;

}

/* confirm booking prompt START  */
const accept = (e) => {
    executeBookingPayment();
};

const reject = (e) => {
    //op.current.toggle(e);
};

const confirm = (event) => {
    confirmDialog({
        target: event.currentTarget,
        header: 'Confirmação de Pagamento',
        message: <div style={{maxWidth:"30rem"}}>Tem certeza que deseja efetivar o pagamento com os dados informados? Caso ocorra algum erro, você será informado nessa tela.</div>,
        icon: 'pi pi-exclamation-triangle',
        accept,
        reject,
        dismissableMask:true,
        blockScroll:true,
        rejectLabel:"Não, vou revisar.",
        acceptLabel:"Sim, vou prosseguir!"
    });
};
/* confirm booking prompt END  */


// helpers locais
const normalizeDigits = (v = '') => String(v).replace(/\D/g, '');
const normalizeCard = (v = '') => String(v).replace(/\s+/g, '');
const toTitleCase = (s = '') => s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s;

// mapeia a bandeira do Utils (lowercase) para o formato do backend (ex.: "Visa")
const mapBrandForApi = (raw) => {
  const b = String(raw || '').toLowerCase();
  const map = {
    visa: 'Visa',
    mastercard: 'Master',
    amex: 'Amex',
    elo: 'Elo',
    hipercard: 'Hipercard',
    diners: 'Diners',
    discover: 'Discover',
    outros: 'Unknown'
  };
  return map[b] || toTitleCase(b);
};

const executeBookingPayment = async () => {

  try {

    setLoadingPayment(true);

    // 1) Forma de pagamento: só cartão (activeIndex === 0) por enquanto
    if (activeIndex !== 0) {
      setLoadingPayment(false);
      setAlertTitle('Forma de pagamento não disponível');
      setAlertBody('No momento só estamos processando pagamento por cartão de crédito. Selecione “Cartão de crédito”.');
      setAlert(true);
      return;
    }
 
    // 2) Coleta e normalização dos campos do cartão
    const numberRaw = normalizeCard(formFields.cardNumber);          // ex.: "4111111111111118"
    const holderRaw = (formFields.cardHolderName || '').trim();         // ex.: "Fulano da Silva"
    const expRaw    = (formFields.cardExpiry || '').trim();     // ex.: "12/2026" ou "12/26"
    const cvvRaw    = normalizeDigits(formFields.cardCvv);          // ex.: "123"

    // 3) Validações usando Utils.js
    if (!validarNumeroCartao(numberRaw)) {
      setLoadingPayment(false);
      setAlertTitle('Dados do cartão');
      setAlertBody('Número do cartão inválido. Confira e tente novamente.');
      setAlert(true);
      return;
    }

    if (!validarNomeCartao(holderRaw)) {
      setLoadingPayment(false);
      setAlertTitle('Dados do cartão');
      setAlertBody('Nome do portador inválido. Informe nome e sobrenome.');
      setAlert(true);
      return;
    }

    if (!validarValidadeCartao(expRaw)) {
      setLoadingPayment(false);
      setAlertTitle('Dados do cartão');
      setAlertBody('Validade do cartão inválida. Use o formato MM/AAAA ou MM/AA.');
      setAlert(true);
      return;
    }

    if (!cvvRaw || cvvRaw.length < 3) {
      setLoadingPayment(false);
      setAlertTitle('Dados do cartão');
      setAlertBody('Código de segurança (CVV) inválido.');
      setAlert(true);
      return;
    }

    if (!formFields.installments) {
      setLoadingPayment(false);
      setAlertTitle('Dados do cartão');
      setAlertBody('Número de parcelas inválido. É necessário informar o número de parcelas.');
      setAlert(true);
      return;
    }

    // 4) Identifica bandeira
    const detectedBrand = getCardBrand(numberRaw);         // ex.: "visa"
    const brandForApi   = mapBrandForApi(detectedBrand);   // ex.: "Visa"
    
    // 4.1) Verificsa se a bandeira do cartão é aceita
    const acceptedCreditcardBrands = ['Visa', 'Master'];
    if (!acceptedCreditcardBrands.includes(brandForApi)) {
      setLoadingPayment(false);
      setAlertTitle('Dados do cartão');
      setAlertBody('Bandeira do cartão não aceita. Confira e tente novamente.');
      setAlert(true);
      return;
    }      

    // amount: utilize o total a pagar agora (ou o valor devido), sempre com 2 casas decimais
    const originalAmountNumber = advanceComission ? Number(totalAmountPaidNowNoComission) : Number(totalAmountPaidNow);
    const originalAmountStr = originalAmountNumber.toFixed(2); // "4550.00"
    const amountNumber = advanceComission ? Number(totalAmountPaidNowNoComission * exchangeRate) : Number(totalAmountPaidNow * exchangeRate);
    const amountStr = amountNumber.toFixed(2); // "4550.00"
    const comissionAmountNumber = advanceComission ? Number(advanceComissionAmount * exchangeRate) : 0;
    const comissionAmount = comissionAmountNumber.toFixed(2); // "4550.00"
    const comissionAmountCalculated = Number(advanceComissionAmount * exchangeRate);
    const comissionPercentage = advanceComissionPercentage || 0;

    // installments: ajuste conforme seu estado/controle; default 1
    const installments = Number(formFields.installments || 1);

    const paymentData = {
      customer: { 
        name: (responsibleName || '').trim(),
        identity: normalizeDigits(responsibleDocument || ''), // CPF do responsável
        email: (responsibleEmail || '').trim()
      },
      payment: {
        originalAmount: originalAmountStr,
        originalCurrency: "USD",
        exchangeRateUsed: exchangeRate,
        convertedCurrency: "BRL", 
        amount: amountStr,
        advanceCommission:advanceComission,
        comissionAmount,
        comissionAmountCalculated,
        comissionPercentage,
        paymentMethod: activeIndex !== 0 ? 'pix' : 'cc',
        installments,
        creditCard: {
          cardNumber: numberRaw,
          holder: holderRaw,
          expirationDate: expRaw.length === 4
            ? `0${expRaw[0]}/${expRaw.slice(1)}` // fallback extremo, ajuste se necessário
            : expRaw, // esperando "MM/AAAA" ou "MM/AA"
          securityCode: cvvRaw,
          brand: brandForApi
        }
      },   
      bookingVoucherInfo: generateVoucherInfo(),
      bookingId: selectedProperty?.bookingId || null
    };

    // 6) Chama a action headless
    const res = await props.payBooking(paymentData);

    // 7) Trata retorno (endpoint já retorna mensagem friendly)
    if (res?.success) {

      // Scroll to top
      handleClickScroll("navigationSection");

      // dispara Redux para a UI mudar de estado
      props.setPaymentConfirmed(true);

      // Set current payment status to PENDING
      setPaymentStatus('CONFIRMED');      
      
      // guarde o objeto retornado (ajuste depois a estrutura)
      props.setPaymentTransaction(res.data); 
      
      setLoadingPayment(false);
      showSuccess('Pagamento realizado com sucesso!', 'Sua reserva foi confirmada.');
      return;

    }

    // If return is PENDING
    if (res?.data?.pending) {

        // Scroll to top
        handleClickScroll("navigationSection",0);

        // Set current payment status to PENDING
        setPaymentStatus('PENDING');

        // guarde o objeto retornado (ajuste depois a estrutura)
        props.setPaymentTransaction(res.data);         

        setLoadingPayment(false);
        setAlertTitle('Pagamento está pendente.');
        setAlertBody(res?.error || 'O tempo limite de retorno com o serviço de pagamento foi atingido e o pagamento está pendente. Recomendamos que aguarde até que o pagamento seja processado antes de tentar um novo pagamento. Caso inicie um novo pagamento antes do processamento, pode haver duplicidade na cobrança.');
        setAlert(true);

      return;
    } 
   

    // Falha
    setLoadingPayment(false);
    setAlertTitle('Não foi possível concluir o pagamento');
    setAlertBody(res?.error || 'O tempo limite de retorno com o serviço de pagamento foi atingido e o pagamento está pendente. Aguarde até que o pagamento seja processado antes de tentar um novo pagamento.');
    setAlert(true);

  } catch (err) {
    setLoadingPayment(false);
    setAlertTitle('Erro ao processar o pagamento');
    setAlertBody(err?.message || 'O serviço de pagamento pode estar sofrendo instabilidades. Tente novamente em instantes. Se o problema persistir, entre em contato com o suporte via whatsapp.');
    setAlert(true);
  }
};

const executeVerifyPaymentStatus = async () => {
  setVerifyStatusLoading(true);
  try {
    const payload = {
      gatewayPaymentId: paymentTransaction?.transaction?.gatewayPaymentId || null,
    };
    const res = await props.verifyPaymentStatus(payload);

    if (res?.success) {

        // If currentStatus is "captured", você pode atualizar o status da reserva no banco de dados
        if (res?.data?.currentStatus === "captured") {
            handleClickScroll("navigationSection",0);
            setPaymentConfirmed(true);
            return;
        } else if (res?.data?.currentStatus === "voided") {

            // Scroll to top
            handleClickScroll("navigationSection",0);

            setPaymentStatus('VOIDED');

            setAlertTitle('Pagamento foi cancelado.');
            setAlertBody('O pagamento que estava pendente foi cancelado. Inicie um novo pagamento.');
            setAlert(true);
            
            return;
        }

      showSuccess('Status do pagamento verificado com sucesso! Não houve alteração até o momento.');
    } else {
      showError('Falha ao verificar status do pagamento');
    }
  } catch (err) {
    // Handle error
  } finally {
    setVerifyStatusLoading(false);
  }
};  

  return (
    <>

        {(loadingPayment) &&
            <>
            <div className="wrapper" style={{backgroundColor:"#00000066",zIndex:"999999",position:"fixed",left:0,top:0,display:"flex",justifyContent:"center",alignItems:"center",width:"100%",height:"100vh"}}>
    
                    <div style={{backgroundColor:"#FFFFFF",display:"flex",justifyContent:"center",alignItems:"center",width:"50%",height:"50vh",borderRadius:"60px",padding:"30px"}}>
    
                        <div style={{flex:1,display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",width:"30vw"}}>
                            <ProgressSpinner />
                            <div className="formTitle" style={{marginBottom:"15px",marginTop:"15px"}}>Processando o pagamento da reserva...Aguarde! </div>
                            <div className="formSubTitle">Isso levará um breve momento...Aguarde até a conclusão!</div>		
                            <div className="formSubTitle" style={{fontWeight:"bold",display:"flex",alignItems:"center",gap:"0.5rem"}}> <i className="pi pi-exclamation-triangle" style={{fontSize:"2rem",color:"orange"}}></i> Não recarregue ou saia dessa página</div>		                            
                            <div className="formSubTitle">DREAM4: hotéis 4 estrelas que você pode sonhar...</div>		
    
                        </div>
    
                    </div>
    
            </div>
            </>
        }		

    
    <div id="navigationSection" style={{width:"100%",margin:"0",paddingTop:"0px",paddingBottom:"0px",position:"relative",borderRadius:0}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >

            <div style={{minHeight:"600px",height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		
                <div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start"}}>
                            
                    <div style={{flex:1,minHeight:"594px",marginLeft:"auto",marginRight:"auto"}}>
                        
                    <div className="searchWrapper" style={{padding: "3rem",paddingTop:"1.8rem",display: "flex",flexDirection: "column",justifyContent: "center",alignItems: "flex-start",gap: "0.8rem",width: "100%"}}>

                        <div className="backAndsearchFields w100" style={{marginBottom:"1rem"}}>

                                <div className="searchWrapperInput" style={{flex:"1",width:"100%",marginTop:"20px"}}>

                                    <div container style={{width:"100%",maxWidth:"1440px",display:"flex",flexDirection:"row",justifyContent:"end",alignItems:"center",gap:"10px"}}>

                                        <div style={{flex:"1",textAlign:"left"}}>

                                            {!paymentConfirmed &&
                                                <>
                                                <Button icon="pi pi-arrow-left" label="Voltar para reserva" text className="pT10 mR10 backButton" onClick={()=>{navigate('/order/hotel/booking/confirm')}} style={{color:"#814DE5"}} /> 
                                                </>
                                            }
                                        </div>                                      
                                        
                                    </div>

                                                                         
                                </div>												  
                              
                        </div>
        
                     
                        <div id="titleBox" className="titleBox selectBoxTitleOld animateOld flex-row justify-center align-items-center w100" style={{marginBottom:"0px",color: "#1D2939",fontSize: "2rem",fontStyle: "normal",fontWeight: 700,lineHeight: "2.12938rem",fontFamily:"Poppins",flex:"1",gap:"10px",maxWidth:"1440px"}} >


                            {/* LOADING  */}
                            {(contentLoading) &&
                                <>
                                    <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                    
                                        <div style={{flex:1}}>
                                            <Skeleton width="70%" height="5vh" ></Skeleton>
                                        </div>
                                                                                            
                                    </div>
                                                                     
                                </>				
                            }   

                            {/* LOADING  */}
                            {(!contentLoading) &&
                            <>
                                <div style={{textAlign:"left",flex:1,marginBottom:"2.5rem"}}>


                                    <div className="resultsCard_details__left flex-column justify-center align-items-start" style={{gap:"1.5rem",flex:1}}>

                                        {(!paymentConfirmed && paymentStatus == "CREATING") &&
                                            <>
                                            <div className="resultsCard_details__name" style={{color: "#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",
                                            fontStyle: "normal",fontWeight: 700,lineHeight: "normal",textAlign:"left"}}>Efetuando pagamento. Código interno: <span style={{color:"#814DE5"}}>{`${moment().format("YYYY.MM.DD")}${String(selectedProperty?.bookingId ?? "").padStart(4, "0")}`}</span></div>

                                            <div className="resultsCard_details__name" style={{color:"#475467",fontFamily:"Poppins",fontSize:"1.125rem",fontStyle:"normal",fontWeight:400,lineHeight:"160.5%",letterSpacing:"0.1125rem"}}>Efetue o pagamento de sua reserva para emissão do Voucher e código da reserva. <br /> A reserva deve ser paga até <strong>{moment(selectedProperty?.bookingData?.bookingInfo?.cancellationDeadline).format('DD/MM/YYYY')}</strong>, caso contrário, a reserva será automaticamente cancelada.</div>
                                            </>
                                        }

                                        {(paymentConfirmed) &&
                                            <>
                                            <div className="resultsCard_details__name" style={{color: "#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",
                                            fontStyle: "normal",fontWeight: 700,lineHeight: "normal",textAlign:"left"}}>Pagamento efetuado. Código interno: <span style={{color:"#814DE5"}}>{`${moment().format("YYYY.MM.DD")}${String(selectedProperty?.bookingId ?? "").padStart(4, "0")}`}</span></div>

                                            <div className="resultsCard_details__name" style={{color:"#475467",fontFamily:"Poppins",fontSize:"1.125rem",fontStyle:"normal",fontWeight:400,lineHeight:"160.5%",letterSpacing:"0.1125rem"}}>O pagamento de sua reserva foi efetuado com sucesso. <br /> Caso queira cancelar a mesma sem custos, você pode fazer o cancelamento até <strong>{moment(selectedProperty?.bookingData?.bookingInfo?.cancellationDeadline).format('DD/MM/YYYY')}</strong>.<br /> Para cancelar após esse prazo entre em contato com a central de atendimento.</div>
                                            </>
                                        }

                                        {(!paymentConfirmed && paymentStatus == "PENDING") &&
                                            <>
                                            <div className="resultsCard_details__name" style={{color: "#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",
                                            fontStyle: "normal",fontWeight: 700,lineHeight: "normal",textAlign:"left"}}>Pagamento pendente. Código interno: <span style={{color:"#814DE5"}}>{`${moment().format("YYYY.MM.DD")}${String(selectedProperty?.bookingId ?? "").padStart(4, "0")}`}</span></div>

                                            <div className="resultsCard_details__name" style={{color:"#475467",fontFamily:"Poppins",fontSize:"1.125rem",fontStyle:"normal",fontWeight:400,lineHeight:"160.5%",letterSpacing:"0.1125rem"}}>O pagamento de sua reserva está pendente. <br />Aguarde a confirmação do pagamento e retorne posteriormente ou aperte o botão abaixo para verificar o status do pagamento.</div>
                                            </>
                                        }                                        

                                        {(!paymentConfirmed && paymentStatus == "VOIDED") &&
                                            <>
                                            <div className="resultsCard_details__name" style={{color: "#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",
                                            fontStyle: "normal",fontWeight: 700,lineHeight: "normal",textAlign:"left"}}>Pagamento cancelado. Código interno: <span style={{color:"#814DE5"}}>{`${moment().format("YYYY.MM.DD")}${String(selectedProperty?.bookingId ?? "").padStart(4, "0")}`}</span></div>

                                            <div className="resultsCard_details__name" style={{color:"#475467",fontFamily:"Poppins",fontSize:"1.125rem",fontStyle:"normal",fontWeight:400,lineHeight:"160.5%",letterSpacing:"0.1125rem"}}>O pagamento de sua reserva foi cancelado. Inicie um novo pagamento. <br />Para mais informações, entre em contato com a central de atendimento.</div>
                                            </>
                                        }                                        

                                    </div>

                                </div>
                            </>
                            }
                
                        </div>
        

                        <div className="navigationContentWrapper flex-row justify-center align-items-start" style={{maxWidth:"1440px",marginTop:"0",width:"100%",flex:1,gap:"1rem"}}>

                                    <div className="resultsWrapper flex-column justify-center align-items-center" style={{gap:"1rem",flex:1}}>

                                        {/* BOOKING SUMMARY START */}  
                                        <div className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div className="w100 flex-row justify-center align-items-stretch" style={{gap:"40px",height:"50vh"}}>
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="20rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>                              
                                                        </div>                                              
                                                    </div>
                                                </>				
                                            }                                            

                                            {/* LOADING  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                                                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

                                                        <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
                                            
                                                            <div className="bookingDetails_title">Dados da reserva</div>

                                                            <div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"745px"}}>

                                                                {currentAgency.agencyName &&
                                                                <>
                                                                    <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                        <div className="bookingDetails_wrapper_item_label">Agência</div>
                                                                        <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                        <div className="bookingDetails_wrapper_item_value">{currentAgency.agencyName || "Não definido"}</div>
                                                                    </div>
                                                                </>
                                                                }

                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Código da reserva</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">

                                                                        {!paymentConfirmed &&
                                                                            <Message severity="warn" text="Aguardando Pagamento" />
                                                                        }

                                                                        {paymentConfirmed &&
                                                                          <span>{selectedProperty?.bookingReservationCode || "-"}</span>
                                                                        }
                                                                        
                                                                    </div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Voucher da reserva</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">
                                                                        
                                                                        {!paymentConfirmed &&
                                                                            <Message severity="warn" text="Aguardando Pagamento" />
                                                                        }

                                                                        {paymentConfirmed &&
                                                                            <Button label="Baixar PDF do Voucher" loading={loadingQuote} icon="pi pi-file-pdf" className="p-button-outlined p-button-secondary" onClick={handleDownloadVoucher} />
                                                                        }

                                                                    </div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Data de hospedagem</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.dateRange ? (moment(selectedProperty?.dateRange[0]).format("DD/MM/YYYY") + " a " +moment(selectedProperty?.dateRange[1]).format("DD/MM/YYYY")) : "carregando..."}</div>
                                                                </div>

                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Código Interno</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{`${moment().format("YYYY.MM.DD.")}${String(selectedProperty?.bookingId ?? "").padStart(4, "0")}`}</div>
                                                                </div>                                                                

                                                            </div>

                                                        </div>

                                                    </div> 

                                                </div>

                                            </>
                                            }

                                        </div>
                                        {/* BOOKING SUMMARY END */}  


                                        {/* HOTEL DETAILS - START */}
                                        <div className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div className="w100 flex-row justify-center align-items-stretch" style={{gap:"40px",height:"50vh"}}>
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="20rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>                              
                                                        </div>                                              
                                                    </div>
                                                </>				
                                            }                                            

                                            {/* LOADING  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                                                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

                                                        <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
                                            
                                                            <div className="bookingDetails_title">Resumo das seleções</div>

                                                            <div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"745px"}}>

                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Destino selecionado</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.property?.country ? (selectedProperty.property.country +","+selectedProperty.property.city) : "carregando..." }</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Hotel selecionado</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.property?.hotel_name || "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Data de hospedagem</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.dateRange ? (moment(selectedProperty?.dateRange[0]).format("DD/MM/YYYY") + " a " +moment(selectedProperty?.dateRange[1]).format("DD/MM/YYYY")) : "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Número de diárias</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty.dateRangeDays || "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Número de hospedes</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.hostsLabel || "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem",marginTop:"2rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Quarto 1</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.room?.[0]?.room?.title || "carregando..."}</div>
                                                                </div>  


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Hóspedes</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.hostsLabel || "carregando..."}</div>
                                                                </div>


                                                                {selectedProperty.room.map((item, index) =>{

                                                                        const valueAdds = item.valueAdds ? item.valueAdds?.["value-add"] : item?.["value-adds"]?.["value-add"]; // Safe access
                                                                        
                                                                        const totalPricewithMarkup = item?.updatedPriceWithMarkup || item.totalWithMarkup;
                                                                        
                                                                        const rawFee = item?.localCollectedFee?.fees || item?.localCollectedFee;

                                                                        const localCollectedFee = Array.isArray(rawFee)
                                                                        ? rawFee.filter(f => f?.relation === 'display' || f?.relation === undefined)
                                                                        : rawFee;


                                                                        // Função para verificar se um código específico está presente
                                                                        const hasCode = (code) => {
                                                                            if (!valueAdds) return false;

                                                                            // Verifica se é um array
                                                                            if (Array.isArray(valueAdds)) {
                                                                            return valueAdds.some((valueAdd) => valueAdd.code === code);
                                                                            }

                                                                            // Caso seja um objeto único
                                                                            return valueAdds.code === code;
                                                                        };

                                                                    
                                                                        // Set Deadline if origin is hyperguest
                                                                        if (selectedProperty.origin == "hyperguest") {
                                                                            const daysBefore = item.cancellationPolicies?.[0]?.daysBefore || 0;
                                                                            const cancellationDeadline = moment(dateRange[0]).businessSubtract(daysBefore, 'days').format('YYYY-MM-DD')
                                                                            item['cancellation-deadline'] = cancellationDeadline;
                                                                        }
                                                                                                                    
                                                                        // const hasFreeCancellation = hasCode("free_cancellation");
                                                                        const hasFreeCancellation = item['cancellation-deadline'] ? item['cancellation-deadline'] : false;
                                                                        const hasFreeBreakfast = hasCode("free_breakfast");


                                                                        return(
                                                                        <>
                                                                            <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                <div className="bookingDetails_wrapper_item_label">Extras</div>
                                                                                <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                                <div className="bookingDetails_wrapper_item_value">                                      {hasFreeBreakfast && <>Café da manhã incluído</> }
                                                                                     {!hasFreeBreakfast && <>Nenhuma opção extra</>}  
                                                                                  </div>
                                                                            </div>  


                                                                            <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                <div className="bookingDetails_wrapper_item_label">Cancelamento</div>
                                                                                <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                                <div className="bookingDetails_wrapper_item_value">
                                                                                    
                                                                                    {hasFreeCancellation && <>Cancelamento Gratuito <label style={{color:"#878787"}}>até {moment(item['cancellation-deadline']).businessSubtract(2, 'days').format('DD/MM/YYYY')}</label></>}
                                                                                    {!hasFreeCancellation && <>Cancelamento não reembolsável</>}
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        );

                                                                })}

                                                                {localCollectedFeeItems?.length > 0 && (
                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label tAlignL">Tarifas cobradas no local</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">

                                                                        {localCollectedFeeItems.map((item, index) => (
                                                                            <div key={index} className="bookingDetails_wrapper_item_value_item tAlignR">
                                                                                {item.name}: {formatNumberCurrency(item.total, item.currency || currencyCollectedFeeAmount)}
                                                                            </div>
                                                                        ))}
    
                                                                    </div>
                                                                </div>)
                                                                }

                                                            </div>

                                                            <div className="bookingTotals" style={{marginTop:"4rem",width:"80%",maxWidth:"745px"}}>


                                                                    {/* TOTALS */}
                                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%", gap:"0.5rem"}}>

                                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{padding:"0.5rem", gap:"0.5rem", width:"100%"}}>

                                                                            <div className="flex-column justify-center align-items-right w100">

                                                                                {/* Total da hospedagem */}
                                                                                <div className="bookingTotals_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                    <div className="bookingTotals_wrapper_item_label">Total da hospedagem</div>
                                                                                    <div className="bookingTotals_wrapper_item_line flex-1"></div>
                                                                                    <div className="bookingTotals_wrapper_item_value">
                                                                                        {formatNumberCurrency(totalAmount, exchangeRateInitials)}
                                                                                        {nonUsdFees.length > 0 && nonUsdFees.map((fee, idx) => (
                                                                                            <span key={idx}> + {formatNumberCurrency(fee.total, fee.currency)}</span>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>

                                                                                {/* Inclui impostos e taxas */}
                                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "#878787", fontFamily: "Titillium Web", fontSize: "0.85rem", fontWeight: 400, lineHeight: "1.625rem", letterSpacing: "0.02875rem", textAlign:"right"}}>
                                                                                    inclui impostos e taxas
                                                                                </div>

                                                                                {/* Pagar na reserva */}
                                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color:"#878787", fontFamily: "Poppins", fontSize: "1rem", fontWeight: 400, lineHeight: "2.12938rem", textAlign:"right", marginTop:"1rem"}}>
                                                                                    <span style={{fontSize:"0.85rem"}}>Pagar na reserva </span>
                                                                                    {formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}
                                                                                </div>

                                                                                {/* Pagar na propriedade */}
                                                                                {collectedFeeDetails.length > 0 && (
                                                                                    <div className="resultsCard_details__prices___dailyPrice w100" style={{color:"#878787", fontFamily: "Poppins", fontSize: "1rem", fontWeight: 400, lineHeight: "2.12938rem", textAlign:"right", marginTop:"1rem"}}>
                                                                                        <span style={{fontSize:"0.85rem"}}>Pagar na propriedade </span>
                                                                                        {collectedFeeDetails.map((fee, idx) => (
                                                                                            <span key={idx}>{idx > 0 ? " + " : ""}{formatNumberCurrency(fee.total, fee.currency)}</span>
                                                                                        ))}
                                                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "rgb(183 183 183)", lineHeight:"1rem", fontFamily: "Titillium Web", fontSize: "0.75rem", fontWeight:600, textAlign:"right"}}>
                                                                                            Os impostos e/ou taxas a serem pagos na propriedade serão pagos sempre na moeda local.
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                            </div>   

                                                                        </div>

                                                                    </div>
                                                                    {/* TOTALS END */}


                                                            </div>

                                                        </div>

                                                    </div> 

                                                </div>

                                            </>
                                            }

                                        </div>
                                        {/* HOTEL DETAILS - END */}  

                                        {/* HOTEL ADDITIONAL INFO - START */}
                                        <div className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div className="w100 flex-row justify-center align-items-stretch" style={{gap:"40px",height:"50vh"}}>
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="20rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>                              
                                                        </div>                                              
                                                    </div>
                                                </>				
                                            }                                            

                                            {/* LOADING  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                                                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"start",alignItems:"center",position:"relative"}}>

                                                        <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem",maxWidth:"745px"}}>
                                            
                                                            <div className="bookingDetails_title">Quarto: {selectedProperty.room?.[0]?.room?.title || "carregando..."}</div>

                                                            <div className="bookingDetails_subtitle">Solicitação especial</div>

                                                            <div className="bookingDetails_description">Veja os detalhes da sua solicitação especial. Importante: a sua solicitação não está garantida e, se você não receber nenhuma resposta, entre em contato diretamente com a propriedade para confirmar.</div>

                                                            <div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem"}}>

                                                                <div className="card flex justify-content-center w100 tAlignL">
                                                                    <span className="p-float-label w100">
                                                                        {bookingData?.bookingVoucherInfo?.room?.room_additional_info || "Nenhuma solicitação especial foi feita."}
                                                                    </span>
                                                                </div>                                                              
                                                                
                                                            </div>

                                                        </div>

                                                    </div> 

                                                </div>

                                            </>
                                            }

                                        </div>


                                        {/* HOTEL DETAILS - END */}                                                                 

                                    </div>
                                    
                                    {/* RIGHT COLUMN WITH CART DETAILS*/}
                                    <div className="filterWrapper flex-column justify-center align-items-start" style={{width:"25rem",height:"auto",gap:"1.5rem"/*,position:"sticky",top:"90px"*/}}>

                                        {/* Responsavel pela reserva e hospedes */}
                                        {(!paymentConfirmed && paymentStatus == "CREATING") &&
                                            <>
                                            <div className="filterOptions flex-column justify-center align-items-center" style={{width:"100%",height:"auto",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"1rem"}}>

                                                {/* Responsavel pela reserva e hospedes BLOCK */}
                                                <div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"0.5rem"}}>Responsável pelo pagamento</div>

                                                {/* LOADING  */}
                                                {(contentLoading) &&
                                                    <>
                                                        <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                                        
                                                            <div style={{flex:1}}>
                                                                <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                                <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                                <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                                <Skeleton width="100%" height="5vh" ></Skeleton><br />      
                                                                <Skeleton width="100%" height="5vh" ></Skeleton>
                                                                
                                                            </div>
                                                                                                                
                                                        </div>
                                                                                        
                                                    </>				
                                                }   	

                                                {/* LOADED  */}
                                                {(!contentLoading) &&
                                                <>
                                                    <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                        <Grid container spacing={4} style={{width:"100%"}}>

                                                            {responsibleIsGuest &&
                                                            <>
                                                            <Grid item xs={12} sm={12} >
                                                                <div className="flex-row justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                        <label><i className="pi pi-check green mR10"></i>O responsável é um dos hóspedes</label>
                                                                    </div>
                                                                </Grid>  
                                                            </>
                                                            }   

                                                            {responsibleDocumentType &&
                                                            <>
                                                                <Grid item xs={12} sm={12} >
                                                                    <div className="flex-row justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                        <label><i className="pi pi-check green mR10"></i>O responsável é estrangeiro</label>
                                                                    </div>
                                                                </Grid>  
                                                            </>
                                                            }                                                           

                                                            <Grid item xs={12} sm={12} >
                                                                <div className="flex-column justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                    <div className="w100 p-inputgroup">
                                                                        <InputText
                                                                        id="responsibleDocument"
                                                                        className="w100 tAlignL" 
                                                                        value={responsibleDocument}
                                                                        disabled={true}                                                            
                                                                        placeholder={responsibleDocumentType ? "Informe o número do passaporte" : "Informe o CPF"}
                                                                        style={{width:"100%"}}
                                                                        />                                                                                                           
                                                                    </div>                                                        
                                                                </div>                                                           
                                                            </Grid>
                                                            

                                                            <Grid item xs={12} sm={12} >
                                                                <div className="flex-column justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                    <span className="w100 p-float-label">
                                                                        <InputText
                                                                        id="responsibleName"
                                                                        className="w100 tAlignL" 
                                                                        value={responsibleName}
                                                                        disabled={true}
                                                                        onChange={(e) => setResponsibleName(e.target.value)}
                                                                        placeholder={responsibleDocumentType ? "Informe o nome completo" : "Automático / Preencha o CPF"}
                                                                        style={{width:"100%"}}
                                                                        />
                                                                        <label className="w100 tAlignL"  htmlFor="name">Nome completo</label>
                                                                    </span>
                                                                </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={12} >
                                                                <div className="w100" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                                    <span className="w100 p-float-label">
                                                                        <InputText
                                                                            id="responsibleBirthDate"
                                                                            className="w100 tAlignL"
                                                                            value={responsibleBirthDate}
                                                                            disabled={true}                                                                  
                                                                            style={{ width: "100%" }}
                                                                        />
                                                                        <label className="w100 tAlignL" htmlFor="responsibleBirthDate">Data de nascimento</label>
                                                                    </span>

                                                                    <span style={{ position: "absolute", top: '0px', right: '15px', color: '#999', transform: "translateY(50%)" }}>
                                                                        {calcularIdade(responsibleBirthDate) ? `${calcularIdade(responsibleBirthDate)} anos` : ''}
                                                                    </span>
                                                                </div>
                                                            </Grid>
                                                            
                                                            <Grid item xs={12} sm={12} >
                                                                <div className="flex-column justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                    <span className="w100 p-float-label">
                                                                        <InputText
                                                                        id="responsibleEmail"
                                                                        className="w100 tAlignL" 
                                                                        value={responsibleEmail}
                                                                        disabled={true}
                                                                        placeholder="Informe o Email do responsável"
                                                                        style={{width:"100%"}}
                                                                        />
                                                                        <label className="w100 tAlignL"  htmlFor="name">Email</label>
                                                                    </span>
                                                                </div>
                                                        
                                                            </Grid> 

                                                            <Grid item xs={12} sm={12} >
                                                                <div className="flex-column justify-content-start align-items-center gap-1" style={{gap:"0.5rem"}}>
                                                                    <span className="w100 p-float-label">
                                                                        <InputText
                                                                        id="responsiblePhone"
                                                                        className="w100 tAlignL" 
                                                                        value={responsiblePhone}
                                                                        disabled={true}
                                                                        placeholder="Informe o telefone celular do responsável"
                                                                        style={{width:"100%"}}
                                                                        />
                                                                        <label className="w100 tAlignL"  htmlFor="name">Telefone celular</label>
                                                                    </span>
                                                                </div>
                                                        
                                                            </Grid>                                                         
                                                                                                                                

                                                        </Grid>

                                                        

                                                    </div>

                                                    <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
                                                        <img src={iconResponsibleWarning} alt="Aviso de Responsável" style={{width:"2.5rem",height:"auto"}} />
                                                        <div className="advanceComissionWarningSmall"> Se o pagamento for com cartão de crédito o mesmo deve pertencer ao responsável pelo pagamento acima. Se não for o caso, você deverá entrar em contato com a Central de atendimento.</div>
                                                    </div>

                                                </>
                                                }

                                            </div>     
                                            </>
                                        }
                                           
                                        {/* Antecipar Comissão */}
                                        {(!paymentConfirmed && paymentStatus == "CREATING") &&
                                            <>
                                            <div className="filterOptions flex-column justify-center align-items-center" style={{width:"100%",height:"auto",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem"}}>

                                                <div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"0.5rem"}}>Antecipar comissão</div>

                                                {/* LOADING  */}
                                                {(contentLoading) &&
                                                    <>
                                                        <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                                        
                                                            <div style={{flex:1}}>
                                                                <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                                <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                                <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                                <Skeleton width="100%" height="5vh" ></Skeleton><br />      
                                                                <Skeleton width="100%" height="5vh" ></Skeleton>
                                                                
                                                            </div>
                                                                                                                
                                                        </div>
                                                                                        
                                                    </>				
                                                }   	

                                                {/* LOADED  */}
                                                {(!contentLoading) &&
                                                <>
                                                    <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                        <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%",gap:"0.5rem"}}>

                                                            <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"0.5rem",padding:"0.5rem"}}>
                                                                <div className="advanceComissionWarning">Marque a opção abaixo caso queria retirar do valor final a quantia de <strong>{formatNumberCurrency(advanceComissionAmount * exchangeRate, "BRL")}</strong> referente aos <strong>{advanceComissionPercentage + "%"}</strong> de comissão da agência.</div>
                                                            </div>                                                        
                                                        
                                                            <div className="filterOptions_priceFilter__options flex-column justify-start align-items-start" style={{gap:"1rem",width:"100%"}}>

                                                                        <div className="flex-row justify-content-start align-items-center gap-1" style={{gap:"1rem"}}>
                                                                                <InputSwitch
                                                                                id="advanceComission"
                                                                                checked={advanceComission}
                                                                                onChange={(e) => setAdvanceComission(e.value)}
                                                                                />
                                                                                <label htmlFor="advanceComission">Quero retirar a comissão da agência</label>
                                                                        </div>
                                                                
                                                            </div>
                                                        
                                                        </div>

                                                    <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
                                                        <img src={iconResponsibleWarning} alt="Aviso de antecipação de comisssão" style={{width:"2.5rem",height:"auto"}} />
                                                        <div className="advanceComissionWarningSmall">Ao retirar a comissão da agência do valor final de pagamento a mesma deve ser cobrada pela agência diretamente do cliente final.</div>
                                                    </div>


                                                    </div>

                                                </>
                                                }

                                            </div>
                                            </>
                                        }

                                        {/* Resumo da reserva */}
                                        <div className="filterOptions flex-column justify-center align-items-center" style={{width:"100%",height:"auto",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"0rem"}}>

                                            {(paymentConfirmed) &&
                                                <>
                                                <div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"0.5rem"}}>Pagamento confirmado</div>
                                                </>
                                            }

                                            {(!paymentConfirmed && paymentStatus == "PENDING") &&
                                                <>
                                                <div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"0.5rem"}}>Pagamento pendente</div>
                                                </>
                                            }

                                            {(!paymentConfirmed && paymentStatus == "VOIDED") &&
                                                <>
                                                <div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"0.5rem"}}>Pagamento cancelado</div>
                                                </>
                                            }

                                            {(!paymentConfirmed && paymentStatus != "PENDING") &&
                                                <>
                                                <div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"0.5rem"}}>Formas de pagamento</div>                                            
                                                </>
                                            }

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                                    
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />      
                                                            <Skeleton width="100%" height="5vh" ></Skeleton>
                                                            
                                                        </div>
                                                                                                            
                                                    </div>
                                                                                    
                                                </>				
                                            }   	

                                            {/* LOADED PAYMENT METHODS  */}
                                            {(!contentLoading && (!paymentConfirmed && paymentStatus == "CREATING")) &&
                                            <>
                                                <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%",gap:"0.5rem"}}>

                                                        {responsibleIsGuest &&
                                                        <>
                                                            <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"0.5rem",padding:"0.5rem"}}>
                                                                <div className="advanceComissionWarning">Escolha a forma de pagamento desejada e preencha os dados</div>
                                                            </div>                                                           
                                                        
                                                            <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{gap:"1rem",width:"100%"}}>

                                                                <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem"}}>
    
                                                                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                                                        <TabPanel header="Cartão de crédito">
                                                                            <Grid container spacing={2} style={{width:"100%",marginTop:"0.5rem"}}>
                                                                                <Grid item xs={12} sm={12}>
                                                                                <div className="w100 tAlignL formControl" style={{ position: 'relative' }}>
                                                                                    <label htmlFor="cardNumber">Número do cartão <span className="requiredField">*</span></label>
                                                                                    <InputText
                                                                                    id="cardNumber"
                                                                                    value={formFields.cardNumber}
                                                                                    onChange={(e) => {
                                                                                        const rawValue = e.target.value.replace(/\D/g, '');
                                                                                        const masked = maskCreditcard(rawValue);
                                                                                        handleFieldChange('cardNumber', masked);
                                                                                        
                                                                                        // 🔍 Detectar bandeira
                                                                                        if (/^4/.test(rawValue)) handleFieldChange('cardBrand', 'visa');
                                                                                        else if (/^5[1-5]/.test(rawValue)) handleFieldChange('cardBrand', 'mastercard');
                                                                                        else if (/^3[47]/.test(rawValue)) handleFieldChange('cardBrand', 'amex');
                                                                                        else if (/^6(?:011|5)/.test(rawValue)) handleFieldChange('cardBrand', 'discover');
                                                                                        else handleFieldChange('cardBrand', 'creditcard');
                                                                                    }}
                                                                                    onBlur={() => {
                                                                                        handleBlur();
                                                                                    }}
                                                                                    className="w100"
                                                                                    placeholder="**** **** **** ****"
                                                                                    style={{ paddingRight: '3rem' }}
                                                                                    maxLength={formFields.cardBrand == 'amex' ? 18 : 19} // 16 digits + 3 spaces
                                                                                    />

                                                                                    {formFields.cardBrand && (
                                                                                    <img
                                                                                        src={cardIcons[formFields.cardBrand]}
                                                                                        alt={formFields.cardBrand}
                                                                                        style={{
                                                                                        position: 'absolute',
                                                                                        right: '15px',
                                                                                        top: '5px',
                                                                                        transform: 'translateY(50%)',
                                                                                        height: '40px',
                                                                                        pointerEvents: 'none'
                                                                                        }}
                                                                                    />
                                                                                    )}
                                                                                    <small className="fLight">Não aceitamos cartões de crédito virtuais de uso único.</small>                  
                                                                                </div>
                                                                                </Grid>
                                                                                <Grid item xs={12} sm={12}>
                                                                                <div className="w100 tAlignL formControl">
                                                                                    <label htmlFor="cardHolderName">Nome impresso no cartão <span className="requiredField">*</span></label>
                                                                                    <InputText
                                                                                    id="cardHolderName"
                                                                                    value={formFields.cardHolderName}
                                                                                    onChange={(e) => handleFieldChange('cardHolderName', e.target.value)}
                                                                                    onBlur={() => {
                                                                                        handleBlur();
                                                                                    }}
                                                                                    placeholder="Nome como impresso no cartão"
                                                                                    className="w100"
                                                                                    />
                                                                                </div>
                                                                                </Grid>
                                                                                <Grid item xs={8}>
                                                                                <div className="w100 tAlignL formControl">
                                                                                    <label htmlFor="cardExpiry">Validade <span className="requiredField">*</span></label>
                                                                                    <InputText
                                                                                    id="cardExpiry"
                                                                                    value={formFields.cardExpiry}
                                                                                    onChange={(e) => {
                                                                                    const masked = maskCardExpiry(e.target.value);
                                                                                    handleFieldChange('cardExpiry', masked.value);
                                                                                    }}
                                                                                    onBlur={() => {
                                                                                    handleBlur();
                                                                                    }}
                                                                                    className="w100"
                                                                                    placeholder="MM/AA"
                                                                                    maxLength={5}
                                                                                />
                                                                                </div>
                                                                                </Grid>
                                                                                <Grid item xs={4}>
                                                                                <div className="w100 tAlignL formControl">
                                                                                    <label htmlFor="cardCvv">CVV <span className="requiredField">*</span></label>
                                                                                    <InputText
                                                                                    id="cardCvv"
                                                                                    value={formFields.cardCvv}
                                                                                    onChange={(e) => handleFieldChange('cardCvv', e.target.value)}
                                                                                    onBlur={() => handleBlur()}
                                                                                    className="w100"
                                                                                    maxLength={formFields.cardBrand === 'amex' ? 4 : 3}
                                                                                    placeholder="CVV"
                                                                                    />
                                                                                </div>
                                                                                </Grid>

                                                                                {!responsibleDocumentType && 
                                                                                <>
                                                                                    <Grid item xs={12} sm={12}>
                                                                                    <div className="w100 tAlignL formControl">
                                                                                        <label htmlFor="cardHolderCpf">CPF do proprietário <span className="requiredField">*</span></label>
                                                                                        <InputText
                                                                                        id="cardHolderCpf"
                                                                                        value={responsibleDocument ? responsibleDocument : formFields.cardHolderCpf}
                                                                                        onChange={(e) => {
                                                                                            const masked = maskCPF(e.target.value);
                                                                                            handleFieldChange('cardHolderCpf', masked);
                                                                                        }}                    
                                                                                        onBlur={() => {
                                                                                            handleBlur();
                                                                                        }}
                                                                                        readOnly={!!responsibleDocument}
                                                                                        className="w100"
                                                                                        tooltip='Preenchimento automático'
                                                                                        tooltipOptions={{ position: 'bottom',event:'focus' }}
                                                                                        placeholder="000.000.000-00"                    
                                                                                        />
                                                                                        <small>O CPF deve ser o do responsável pelo pagamento.</small>
                                                                                    </div>
                                                                                    </Grid> 
                                                                                </>
                                                                                }

                                                                                <Grid item xs={12} sm={12}>
                                                                                <div className="w100 tAlignL formControl">
                                                                                    <label htmlFor="installments">Forma de Pagamento / Parcelamento <span className="requiredField">*</span></label>
                                                                                    <Dropdown
                                                                                        options={installmentsOptions}
                                                                                        optionLabel="label"        // Campo usado para exibir
                                                                                        optionValue="value"        // Campo usado como "value"
                                                                                        id="installments"
                                                                                        value={formFields.installments}
                                                                                        onChange={(e) => {
                                                                                            const selectedOption = installmentsOptions.find(opt => opt.value === e.value);
                                                                                            console.log("Label:", selectedOption?.label); // Aqui você pega o "texto" mostrado
                                                                                            console.log("Objeto inteiro:", selectedOption); // Aqui pega tudo
                                                                                            handleFieldChange('installments', e.value);
                                                                                            handleFieldChange('installmentsLabel', selectedOption?.label);
                                                                                        }}
                                                                                        onBlur={() => {
                                                                                            handleBlur();
                                                                                        }}
                                                                                        className="w100"
                                                                                        tooltip='Selecione o número de parcelas'
                                                                                        tooltipOptions={{ position: 'bottom', event:'focus' }}
                                                                                    />
                                                                                </div>
                                                                                </Grid>                                                                                          
                                                                                <Grid item xs={12}>
                                                                            




                                                                                </Grid>
                                                                            </Grid>

                                                                        </TabPanel>
                                                                        <TabPanel header="PIX (em breve)" disabled>
                                                                            <div>
                                                                                Em breve...
                                                                            </div>
                                                                        </TabPanel>
                                                                    </TabView>
    
                                                                </div>
    
                                                            </div>
                                                        </>
                                                        }

                                                        {!responsibleIsGuest &&
                                                        <>
                                                            <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
                                                                <img src={iconResponsibleWarning} alt="Aviso de antecipação de comisssão" style={{width:"2.5rem",height:"auto"}} />
                                                                <div className="advanceComissionWarningSmall">Não é possível fazer o pagamento dessa reserva pois o responsável pelo pagamento não é um dos hóspedes. Para realizar o pagamento, entre em contato com a central de atendimento via whatsapp ou telefone.</div>
                                                            </div>
                                                        </>    
                                                        }

                                                    </div>

                                                </div>

                                                {selectedProperty.room && selectedProperty.room.length > 0 &&
                                                <>
                                                {/* TOTALS */}
                                                <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%", gap:"0.5rem"}}>

                                                    <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{padding:"0.5rem", gap:"0.5rem", width:"100%"}}>

                                                    <div className="flex-column justify-center align-items-right w100">

                                                        {advanceComission &&
                                                        <>
                                                            <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: " #00A3FF",
                                                            fontFamily: "Poppins",
                                                            fontSize: "1.5rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 600,
                                                            lineHeight: "2.12938rem",
                                                            textAlign: "right"
                                                            }}>
                                                            <span style={{fontSize: "0.9375rem"}}>Total </span>
                                                            {formatNumberCurrency(totalAmountPaidNowNoComission * exchangeRate, exchangeRateCurrency)}
                                                            </div> 

                                                            <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: "red",
                                                            fontFamily: "Poppins",
                                                            fontSize: "1.1rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 600,
                                                            lineHeight: "2.12938rem",
                                                            textAlign: "right"
                                                            }}>
                                                            <span style={{fontSize: "0.9375rem"}}>Comissão antecipada </span>
                                                            {formatNumberCurrency(advanceComissionAmount * exchangeRate, exchangeRateCurrency)}
                                                            </div>                                                                                                                        
                                                        </>
                                                        }

                                                        {!advanceComission &&
                                                        <>
                                                            <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: " #00A3FF",
                                                            fontFamily: "Poppins",
                                                            fontSize: "1.5rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 600,
                                                            lineHeight: "2.12938rem",
                                                            textAlign: "right"
                                                            }}>
                                                            <span style={{fontSize: "0.9375rem"}}>Total </span>
                                                            {formatNumberCurrency(totalAmountPaidNow * exchangeRate, exchangeRateCurrency)} 
                                                            </div>                                                            
                                                        </>
                                                        }

                                                        {(formFields.installments && activeIndex === 0) &&
                                                        <>
                                                            <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: " #00A3FF",
                                                            fontFamily: "Poppins",
                                                            fontSize: "1.1rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 600,
                                                            lineHeight: "2.12938rem",
                                                            textAlign: "right"
                                                            }}>
                                                            {formFields.installmentsLabel}
                                                            </div>  
                                                        </>                                                       
                                                        }

                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                        color: "#878787",
                                                        fontFamily: "Titillium Web",
                                                        fontSize: "0.85rem",
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "1.625rem",
                                                        letterSpacing: "0.02875rem",
                                                        textAlign: "right"
                                                        }}>
                                                        inclui impostos e taxas <br /> Taxa de câmbio utilizada: {exchangeRateFormatted} 
                                                        </div>

                                                        {/* Pagar na propriedade */}
                                                        {collectedFeeDetails.length > 0 && (
                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: "#878787",
                                                            fontFamily: "Poppins",
                                                            fontSize: "1rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 400,
                                                            lineHeight: "2.12938rem",
                                                            textAlign: "right",
                                                            marginTop: "1rem"
                                                        }}>
                                                            <span style={{fontSize:"0.85rem"}}>Pagar na propriedade </span>
                                                            {collectedFeeDetails.map((fee, idx) => (
                                                            <span key={idx}>{idx > 0 ? " + " : ""}{formatNumberCurrency(fee.total, fee.currency)}</span>
                                                            ))}
                                                            <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: "rgb(183 183 183)",
                                                            lineHeight: "1rem",
                                                            fontFamily: "Titillium Web",
                                                            fontSize: "0.75rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 600,
                                                            letterSpacing: "0.02875rem",
                                                            textAlign: "right"
                                                            }}>
                                                            Os impostos e/ou taxas a serem pagos na propriedade deverão ser pagos na moeda acima.
                                                            </div>
                                                        </div>
                                                        )}

                                                        {!currentAgency.agencyCode && 
                                                        <>
                                                            <div style={{marginTop:"1rem"}}>
                                                            <ConfirmDialog className="paymentConfirm" />
                                                            <Button
                                                                label="Finalizar pagamento"
                                                                rounded
                                                                disabled={loadingPayment || (!formFields.cardNumber || !formFields.cardHolderName || !formFields.cardExpiry || !formFields.cardCvv || !formFields.cardHolderCpf || !formFields.installments) }
                                                                className="pT10 mR10 headerButton tColorWhite w100"
                                                                onClick={(e) => {confirm(e)}} 
                                                            />
                                                            </div>
                                                        </>
                                                        }

                                                        {currentAgency.agencyCode && 
                                                        <>
                                                            <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
                                                                <img src={iconResponsibleWarning} alt="Aviso de Responsável" style={{width:"2.5rem",height:"auto"}} />
                                                                <div className="responsibleWarning">O pagamento dessa reserva só poderá ser feito pela agência proprietária da mesma. A agência recebeu uma notificação dessa reserva via email.</div>
                                                            </div>
                                                        </>
                                                        }                                                        

                                                    </div>

                                                    </div>

                                                </div>
                                                </>
                                                }

                                            </>
                                            }

                                            {/* LOADED PAYMENT CONFIRMED  */}
                                            {(!contentLoading && paymentConfirmed) &&
                                            <>
                                                <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%",gap:"0.5rem"}}>

                                                
                                                        <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"0.5rem",padding:"0.5rem"}}>
                                                            <div className="advanceComissionWarning">O pagamento da reserva foi realizado com sucesso. Um email com o voucher foi enviado para o endereço cadastrado do seu usuário.</div>
                                                        </div>                                                           
                                                    
                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{gap:"1rem",width:"100%"}}>

                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem"}}>

                                                                <Grid container spacing={2} style={{width:"100%"}}>

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Status:</div>
                                                                            <div style={{color:"green",fontWeight:"bold"}}>Pagamento realizado</div>
                                                                        </div>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Forma de pagamento:</div>
                                                                            <div>
                                                                                {activeIndex === 0 ? "Cartão de crédito" : "PIX"}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>                                                                     

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Valor:</div>
                                                                            <div>
                                                                                {advanceComission &&
                                                                                <>
                                                                                    {formatNumberCurrency(totalAmountPaidNowNoComission * exchangeRate, exchangeRateCurrency)}
                                                                                </>
                                                                                }
 
                                                                                {!advanceComission &&
                                                                                <>
                                                                                    {formatNumberCurrency(totalAmountPaidNow * exchangeRate, exchangeRateCurrency)}
                                                                                </>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </Grid>     

                                                                    {formFields.installments && activeIndex === 0 &&
                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Parcelamento:</div>
                                                                            <div>
                                                                                {formFields.installmentsLabel}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>   
                                                                    }  

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Código do pagamento:</div>
                                                                            <div>
                                                                                {paymentTransaction?.transaction?.merchantOrderId || "N/A"}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>  

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Código da transação:</div>
                                                                            <div>
                                                                                {paymentTransaction?.transaction?.transactionId || "N/A"}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>   

                                                                </Grid>                                                                    
                                                                    
                                                                
                                                            </div>

                                                        </div>

                                                        <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
                                                            <img src={iconResponsibleWarning} alt="Aviso pagamento" style={{width:"2.5rem",height:"auto"}} />
                                                            <div className="advanceComissionWarningSmall">Você pode acessar a reserva quando quiser, assim como os dados de pagamento, na área restrita, acessível no menu do topo.</div>
                                                        </div>
                                                  

                                                    </div>

                                                </div>
                                            </>
                                            }

                                            {(!contentLoading && (!paymentConfirmed && paymentStatus == "PENDING")) &&
                                            <>
                                                <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%",gap:"0.5rem"}}>

                                                
                                                        <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"0.5rem",padding:"0.5rem"}}>
                                                            <div className="advanceComissionWarning">O pagamento da reserva está pendente. Verifique o status do pagamento abaixo ou inicie um novo pagamento. </div>
                                                        </div>                                                           
                                                    
                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{gap:"1rem",width:"100%"}}>

                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem"}}>

                                                                <Grid container spacing={2} style={{width:"100%"}}>

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Status:</div>
                                                                            <div style={{color:"orange",fontWeight:"bold"}}>Pagamento pendente</div>
                                                                        </div>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Forma de pagamento:</div>
                                                                            <div>
                                                                                {activeIndex === 0 ? "Cartão de crédito" : "PIX"}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>                                                                     

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Valor:</div>
                                                                            <div>
                                                                                {advanceComission &&
                                                                                <>
                                                                                    {formatNumberCurrency(totalAmountPaidNowNoComission * exchangeRate, exchangeRateCurrency)}
                                                                                </>
                                                                                }
 
                                                                                {!advanceComission &&
                                                                                <>
                                                                                    {formatNumberCurrency(totalAmountPaidNow * exchangeRate, exchangeRateCurrency)}
                                                                                </>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </Grid>     

                                                                    {formFields.installments && activeIndex === 0 &&
                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Parcelamento:</div>
                                                                            <div>
                                                                                {formFields.installmentsLabel}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>   
                                                                    }  


                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Código do pagamento:</div>
                                                                            <div>
                                                                                {paymentTransaction?.transaction?.merchantOrderId || "N/A"}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>  

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Código da transação:</div>
                                                                            <div>
                                                                                {paymentTransaction?.transaction?.transactionId || "N/A"}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>   


                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-column justify-content-start align-items-center" style={{gap:"0.5rem",marginTop:"1rem"}}>
                                                                            <div><Button label="Verificar status do pagamento" rounded onClick={() => executeVerifyPaymentStatus()} loading={verifyStatusLoading} disabled={verifyStatusLoading} /></div>
                                                                            <div><Button label="Iniciar novo pagamento" text onClick={() => setPaymentStatus("CREATING")} /></div>
                                                                        </div>
                                                                    </Grid>   


                                                                </Grid>                                                                    
                                                                    
                                                                
                                                            </div>

                                                        </div>

                                                        <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"0rem",padding:"0.5rem"}}>
                                                            <img src={iconResponsibleWarning} alt="Aviso pagamento" style={{width:"2.5rem",height:"auto"}} />
                                                            <div className="advanceComissionWarningSmall">Se preferir, você pode acessar a reserva em outro momento e verificar o status do pagamento. Você receberá um email de confirmação se for bem sucedida.</div>
                                                        </div>
                                                  

                                                    </div>

                                                </div>
                                            </>
                                            }                                            

                                            {(!contentLoading && (!paymentConfirmed && paymentStatus == "VOIDED")) &&
                                            <>
                                                <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%",gap:"0.5rem"}}>

                                                
                                                        <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"0.5rem",padding:"0.5rem"}}>
                                                            <div className="advanceComissionWarning">O pagamento da reserva foi cancelado. Inicie um novo pagamento. </div>
                                                        </div>                                                           
                                                    
                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{gap:"1rem",width:"100%"}}>

                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem"}}>

                                                                <Grid container spacing={2} style={{width:"100%"}}>

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Status:</div>
                                                                            <div style={{color:"red",fontWeight:"bold"}}>Pagamento cancelado</div>
                                                                        </div>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Forma de pagamento:</div>
                                                                            <div>
                                                                                {activeIndex === 0 ? "Cartão de crédito" : "PIX"}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>                                                                     

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Valor:</div>
                                                                            <div>
                                                                                {advanceComission &&
                                                                                <>
                                                                                    {formatNumberCurrency(totalAmountPaidNowNoComission * exchangeRate, exchangeRateCurrency)}
                                                                                </>
                                                                                }
 
                                                                                {!advanceComission &&
                                                                                <>
                                                                                    {formatNumberCurrency(totalAmountPaidNow * exchangeRate, exchangeRateCurrency)}
                                                                                </>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </Grid>     

                                                                    {formFields.installments && activeIndex === 0 &&
                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Parcelamento:</div>
                                                                            <div>
                                                                                {formFields.installmentsLabel}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>   
                                                                    }  


                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Código do pagamento:</div>
                                                                            <div>
                                                                                {paymentTransaction?.transaction?.merchantOrderId || "N/A"}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>  

                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-row justify-content-start align-items-center" style={{gap:"0.5rem"}}>
                                                                            <div>Código da transação:</div>
                                                                            <div>
                                                                                {paymentTransaction?.transaction?.transactionId || "N/A"}                              
                                                                            </div>
                                                                        </div>
                                                                    </Grid>   


                                                                    <Grid item xs={12} sm={12}>
                                                                        <div className="w100 tAlignL flex-column justify-content-start align-items-center" style={{gap:"0.5rem",marginTop:"1rem"}}>
                                                                            <div><Button label="Iniciar novo pagamento" text onClick={() => setPaymentStatus("CREATING")} /></div>
                                                                        </div>
                                                                    </Grid>   


                                                                </Grid>                                                                    
                                                                    
                                                                
                                                            </div>

                                                        </div>

                                                        <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"0rem",padding:"0.5rem"}}>
                                                            <img src={iconResponsibleWarning} alt="Aviso pagamento" style={{width:"2.5rem",height:"auto"}} />
                                                            <div className="advanceComissionWarningSmall">Se preferir, você pode acessar a reserva em outro momento e realizar o pagamento. Fique apens atento ao prazo máximo para pagamento.</div>
                                                        </div>
                                                  

                                                    </div>

                                                </div>
                                            </>
                                            }                                            

                                        </div>


                                        {/* BOX Baixar PDF da cotação */}
                                        {!paymentConfirmed &&
                                        <>                                        
                                        <div className="filterOptions flex-row justify-center align-items-center applyPointer" style={{width:"100%",height:"5rem",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"1rem"}} onClick={handleDownloadQuote}>

                                            <div className="quotationButtonLabel w100 tAlignL" > {loadingQuote ? "Baixando..." : "Baixar PDF de Confirmação"}</div>
    
                                            <div>
                                                <Button 
                                                icon={<><img src={iconDownload} alt="Baixar PDF" /></>}
                                                style={{width:"3rem",height:"auto",background:"none",border:0}}
                                            /></div>

                                        </div>
                                        </>
                                        }

                                        {paymentConfirmed &&
                                        <>
                                        <div className="filterOptions flex-row justify-center align-items-center applyPointer" style={{width:"100%",height:"5rem",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"1rem"}} onClick={handleDownloadVoucher}>

                                            <div className="quotationButtonLabel w100 tAlignL" > {loadingQuote ? "Baixando..." : "Baixar PDF de Voucher"}</div>
    
                                            <div>
                                                <Button 
                                                icon={<><img src={iconDownload} alt="Baixar PDF" /></>}
                                                style={{width:"3rem",height:"auto",background:"none",border:0}}
                                            /></div>

                                        </div>
                                        </>
                                        }                                        

                                        {/* BOX Iniciar outra reserva */}
                                        <div className="filterOptions flex-row justify-center align-items-center applyPointer" style={{width:"100%",height:"5rem",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"1rem"}} onClick={handleNewBooking}>

                                            <div className="quotationButtonLabel w100 tAlignL" > {loadingNewBooking ? "Iniciando..." : "Iniciar outra reserva"}</div>

                                            <div>
                                                <Button 
                                                icon={<><img src={iconNewBooking} alt="Iniciar outra reserva" /></>}
                                                style={{width:"3rem",height:"auto",background:"none",border:0}}
                                            /></div>

                                        </div>


                                    </div>

                        </div>


                    </div>				
                    
                    </div>

                </div> 
            </div>

    </div>	

        <Toast ref={toast} position="bottom-center" />

        <AlertView
            alert={alert}
            setAlert={setAlert}
            alertTitle={alertTitle}
            alertBody={alertBody}	
            scrollBlock={false}				
        />


        {/* Contac Us Section */}
        <ContactUs />

        {/* About Us Section */}
        <AboutUs />
    
    </>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser,
  currentAgency:store.appReducer.currentAgency,

  searchType:store.orderReducer.searchType,
  searchParams:store.orderReducer.searchParams,
  searchResultStatus:store.orderReducer.searchResultStatus,
  searchResultRowsNumber:store.orderReducer.searchResultRowsNumber,
  searchResultToken:store.orderReducer.searchResultToken,
  searchResultCurrentPage:store.orderReducer.searchResultCurrentPage,
  searchResultLimit:store.orderReducer.searchResultLimit,
  searchLocation:store.orderReducer.searchLocation,
  searchResultObj:store.orderReducer.searchResultObj,
  searchCurrency:store.orderReducer.searchCurrency,
  exchangeRates:store.orderReducer.exchangeRates,
  selectedProperty:store.orderReducer.selectedProperty,
  currentBooking:store.orderReducer.currentBooking,
  paymentConfirmed:store.orderReducer.paymentConfirmed,
  paymentTransaction:store.orderReducer.paymentTransaction
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions,...OrderActions }, dispatch);

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(BookingPayment);	


